<!-- 账户余额-->
<template>
  <div class="page" v-cloak>

    <van-nav-bar :border="false" left-arrow fixed title="百福币充值" class="on_line_nav_bar" @click-left="onClickLeft" @click-right="goLog" :style="'background: #ff5000; color:#FFFFFF;'">
      <template #right>
        <span>明细</span> 
      </template>
    </van-nav-bar>

    <div class="header-b">
      <div class="header-c">
        <p class="title">当前百福币</p>
        <h3 class="price">{{balance.bfb | numToCash}}</h3>
        <p class="tips">温馨提示：此处充值的实际金额也可以在商城消费</p>
      </div>
    </div>

    <div class="input-block">

      <h3 class="input-title">百福币充值卡</h3>

      <div class="input-center-block">
        <div class="password-input">
          <input type="text" v-model="moneyNo" :placeholder="placeholder" @focus="placeholder=''" @blur="placeholder='卡号(卡券上的卡号)'" />
        </div>

        <div class="password-input">
          <form>
            <input :type="inputType" v-model="password" autocomplete :placeholder="placPassw" @focus="placPassw=''" @blur="placPassw='密码(卡券上刮开的密码)'" />
          </form>
          <div :class="['eye', inputType == 'password' ? 'no_eye_icon' : 'eye_icon']" @click="passwordClick"></div>
        </div>

        <div :class="['next-block', password ? 'next' : '']" @click="goExchange">
          充 值
        </div>
      </div>

    </div>

  </div>
</template>
  
  <script type="text/babel">
import wx from "weixin-js-sdk";
import imgTextBlock from "@/components/img-text-block/img-text-block.vue";
export default {
  name: "onLine",
  components: { imgTextBlock },
  props: {},
  data() {
    return {
      balance: {
        total: 0, // 余额
        bfb: 0, // bfb余额
      },

      moneyNo: "",
      password: "",
      inputType: "password",
      placeholder: "卡号(卡券上的卡号)",
      placPassw: "密码(卡券上刮开的密码)",
    };
  },
  watch: {
    // aa: {
    //   handler(newValue, oldValue) {
    //     console.log(newValue, oldValue);
    //   },
    //   deep: true, // 深度监听表单
    // },
  },
  created() {},
  mounted() {
    
    this.getInit();
  },
  methods: {
    getInit() {
      
      this.$toast.loading();
      let _this = this;
      _this.$post("/api/recharge_index").then((res) => {
        console.log(res.data, "充值页配置");
        if (res.data && res.data.code == 0) {
          _this.$toast.clear();
          _this.balance = res.data.data.balance;
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    // 是否显示密码
    passwordClick(e) {
      const that = this;
      if (that.inputType == "password") {
        that.inputType = "text";
      } else {
        that.inputType = "password";
      }
    },
    // 下一步
    goExchange() {
      let _this = this;
      if (!this.password) return; //密码为空。。
      if (!this.isLogin()) return false;

      _this.goExchangeOrder();
    },
    // 兑换
    goExchange() {
      let _this = this;
      let data = {
        card_code: _this.moneyNo,
        card_pwd: _this.password,
      };
      this.$post("/api/recharge_card_bfb", data, data).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          _this.getInit();
          // console.log(res.data);
          _this.$toast(res.data.message);
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },

    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
    goLog() {
      this.$router.push({ name: "bfb-log-list", query: {} });
    },
    goClause() {
      this.$router.push({ name: "on-line-recharge-clause", query: {} });
    },
  },
};
</script>
  <style lang="scss">
.on_line_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
}
</style>
  
  <style lang="scss" scoped>
.page {
  //   height: 100%;
  width: 100%;
  padding: 0 0 50px 0;
  background-color: #f7f7f7;
  .header-b {
    height: 184px;
    width: 100%;
    background-image: url("../../assets/onLine/online_1.png");
    background-repeat: no-repeat;
    background-size: 100% 130px;
    // background-color: #000;
    padding: 50px 25px 0;

    .header-c {
      height: 130px;
      background: #ffffff;
      border-radius: 10px;
      padding: 15px;
      text-align: left;

      .title {
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
      .price {
        margin-top: 15px;
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        font-weight: bold;
      }
      .tips {
        margin-top: 15px;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: #999999;
      }
    }
  }
  //
  .list-tips {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;

    text-align: left;
    padding: 10px 15px 0;
    overflow: hidden;

    span {
      float: right;
      padding: 5px 10px;
      background: linear-gradient(90deg, #ff5000 0%, #53a0fa 100%);
      border-radius: 10px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .list-tips_n {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;

    padding: 10px 15px 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      padding: 5px 10px;
      background: linear-gradient(90deg, #ff5000 0%, #53a0fa 100%);
      border-radius: 10px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
  }

  .center-prodect-bander {
    padding: 15px 0 0;
    // background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-wrap: wrap;
    .center-prodect-bander-item {
      box-sizing: border-box;
      width: 100%;
      border: 1px solid #f9f9f9;
      background: #ff5000;

      border-radius: 12px;
      text-align: center;
      padding: 15px;
      .price {
        font-size: 15px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        span {
          font-size: 12px;
        }
      }
      .give-price {
        margin-top: 5px;
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;

        span {
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #ffffff;
        }
      }

      .l-r-tips {
        color: #e8fa4c;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        margin-top: 5px;
      }
    }
  }

  //
  .center-bander {
    padding: 15px 0 0;
    // background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-wrap: wrap;

    .center-bander-item {
      box-sizing: border-box;
      width: 45%;
      margin: 0 8px 15px;
      border: 1px solid #f9f9f9;

      border-radius: 12px;
      text-align: center;
      padding: 15px;
      .price {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ff5000;
        span {
          font-size: 12px;
        }
      }
      .give-price {
        margin-top: 5px;
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #f22b2b;

        span {
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #999999;
        }
      }
    }

    .bc0 {
      background: #ff5000;
      .price {
        color: #ffffff !important;
      }

      .give-price {
        color: #ffffff !important;
        span {
          color: #ffffff !important;
        }
      }
    }
    .bc1 {
      background: #ffffff;
    }
  }

  .list {
    padding: 0 15px 30px;
  }
}

.new-goods-center {
  padding: 0 10px 15px;
  //   background-color: green;
  .new-goods-swipe {
    height: 100%;
    width: 100%;
    .van-swipe-item {
      display: flex;
      flex-wrap: wrap;
    }
  }
}

// 底部提示

.foot-tips {
  padding: 15px;
  text-align: left;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;

  .foot-xy {
    margin-top: 30px;
    text-align: center;
    span {
      color: #ff5000;
    }
  }
}

// 横向
.img-text-row {
  margin: 15px;
  padding: 15px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .row-goods-img {
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 24px;
      height: 100%;
    }

    .row-goods-info {
      margin-left: 15px;
      padding: 5px 0;
      text-align: left;
      //  background-color: paleturquoise;

      .row-goods-name {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
    }
  }
  .row-goods-right {
    display: inline-block;
    padding: 5px 10px;
    background: rgba(234, 234, 234, 0.6);
    border-radius: 10px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
  }
}

.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}

.input-block {
  // height: 635px;
  background-color: #fff;
  margin: 30px 10px 0;

  border-radius: 6px;

  .input-title {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    line-height: 30px;
    color: #ff5000;
    letter-spacing: 1px;
    position: relative;
  }
  .input-title::after {
    content: "";
    position: absolute;
    width: 25px;
    height: 2px;
    left: 47%;
    bottom: -5px;
    /* background-color: red; */
    background: #ff5000;
    z-index: 1;
    border-radius: 11px 0 0 0;
    opacity: 0.8;
  }
  .input-center-block {
    padding: 0 15px 15px;
    .password-input {
      // margin: 100px 0;
      width: 100%;
      box-sizing: border-box;
      height: 73px;
      border-bottom: solid 1px #cccccc;
      display: flex;
      justify-content: space-between;
      form {
        width: 90%;
        height: 100%;
      }
      input {
        width: 100%;
        height: 100%;
        text-align: center;
        background: none;
        outline: none;
        border: none;
        font-size: 16px;
      }
      .eye {
        // background-color: #eee;
        width: 16px;
        height: 100%;
        background-repeat: no-repeat;
        background-size: 100% 20%;
        background-position: 0 25px;
      }

      .eye_icon {
        background-image: url("https://qiniu.zdyxjx.com/minizdyxeye.png");
      }
      .no_eye_icon {
        background-image: url("https://qiniu.zdyxjx.com/minizdyxno-eye.png");
      }
    }

    .next-block {
      margin: 15px auto;
      width: 293px;
      height: 40px;
      background: #eeeeee;
      border-radius: 20px;
      background-color: #eee;

      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      line-height: 20px;
      color: #cccccc;
      letter-spacing: 1px;
    }
    .next {
      background-color: #ff5000;
      color: #fff;
    }
  }
}
</style>
  